{
  "povzetek": {
    "title": "Riepilogo",
    "skupno30": "Ultimi 30 giorni",
    "skupno90": "Ultimi 90 giorni",
    "skupno365": "Ultimi 365 giorni",
    "vsiO": "Tutti i voli completati",
    "povprecje": "Durata media del volo",
    "najveckratV": "Aeromobile più utilizzato"
  },
  "povzetekLabel": {
    "dan": "Giorno",
    "slepo": "Strumentale"
  },
  "table": {
    "datum": "Data",
    "letalisce": "Aeroporto",
    "trajanje": "Durata",
    "vzlet": "Decollo",
    "diaryTitle": "Appunti di diario"
  },
  "modal": {
    "datum": "Data:",
    "odhodCas": "Ora di partenza:",
    "kilometri": "Chilometri percorsi:",
    "trajanjeDan": "Durata del volo (giorno):",
    "trajanjeSlepo": "Durata del volo (strumentale):",
    "stLetov": "Numero di voli:",
    "odhod": "Partenza:",
    "krajO": "Luogo di partenza:",
    "nacinStarta": "Metodo di lancio:",
    "zrakoplov": "Aeromobile:",
    "reg": "Registrazione:",
    "vodjaZ": "Comandante:",
    "opomba": "Nota:"
  },
  "labelsLJ": {
    "casO": "Ora di partenza:",
    "casP": "Ora di arrivo:",
    "model": "Modello di aeromobile:",
    "reg": "Registrazione aeromobile:",
    "vodjaZ": "Comandante:",
    "posadka": "Equipaggio singolo / multiplo:",
    "pogoji": "Condizioni di volo:",
    "pD": "Giorno",
    "pN": "Strumentale",
    "stPristankov": "Numero di atterraggi:",
    "ttof": "TTOF:",
    "op": "Modalità di volo:",
    "opD": "Giorno",
    "opN": "Strumentale",
    "vp": "Ruolo del pilota:",
    "fstd": "Tempo FSTD:",
    "opomba": "Nota:",
    "pristanek": "Seleziona atterraggio:",
    "regL": "Seleziona registrazione aliante:",
    "nacinStarta": "Metodo di lancio:"
  },
  "optionsLJ": {
    "aerozaprega": "Traino aereo",
    "vitla": "Verricello"
  },
  "buttons": {
    "urediPodatke": "Modifica dati",
    "posodobiPodatke": "Aggiorna dati",
    "brisiZapis": "Elimina record",
    "brisiIzbiro": "Cancella selezione",
    "natisni": "Stampa",
    "poslji": "Invia"
  }
}